import {Booking} from "@/classes/viewmodels/Booking";
import ValidatedField from "@/classes/global/ValidatedField";

export default class CourierBooking extends Booking {

    constructor() {
        super();

        this.screenSwitches = {

            termsOfShipment: true,
            customsStatus: true
        }

        this.consignment = {

            customerRef: '',
            customerRefTwo: '',
            collectByDate: '',
            collectByTime: '',
            documentsOnly: false,
            insurance: false,
            insuranceType: '',
            description: '',
            comments: '',
            deliveryDate: '',
            deliveryTime: '',
            currency: '',
            value: '',
            service: '',
            termsOfShipment: '',
            termsDescription: ''
        }

        this.customsComments = '';

        this.customs = [];

        this.customsSelect = {

            // customs is an id for the object, when using the checkFieldsForData method (composable) it switches to look at booleans
            // the value of false is never changed or needed
            customs: false,

            kimberlyCerts: false,
            carnet: false,
            ipr: false,
            ti: false,
            opr: false,
            other: false,
            repair: false,
            cites: false,
            tibBondWarehouse: false,
            exportLicence: false,
            freeCirculation: false
        }

        this.tileSelection = {

            shipper: true,
            consignee: false,
            consignment: false,
            dimensions: false,
            documents: false,
            customs: false
        }

        this.tileValidation = {

            shipper: true,
            consignee: true,
            consignment: true,
            dimensions: true,
            customs: true
        }

        this.metaData = {

            shippers: [],
            consignees: [],
            packageTypes: [],
            serviceTypes: [],
            currencies: [],
            billingParties: [],
            countries: [],
            validatedFields: []

        }

        this.tempValidatedFields = [

            //     new ValidatedField('shipperName', true, true, 'Shipper Name'),
            //     new ValidatedField('shipperAddressLine1', true, false, 'Shipper AddressLine 1'),
            //     new ValidatedField('shipperAddressLine2', true, false, 'Shipper AddressLine 2'),
            //     new ValidatedField('shipperCity', true, false, 'Shipper City'),
            //     new ValidatedField('shipperCounty', true, false, 'Shipper County'),
            //     new ValidatedField('shipperPostcode', true, false, 'Shipper Postcode'),
            //     new ValidatedField('shipperCountry', true, false, 'Shipper Country'),
            //     new ValidatedField('shipperVatNumber', true, false, 'Shipper VAT Number'),
            //     new ValidatedField('shipperContactFullName', true, false, 'Shipper Contact Selection'),
            //     new ValidatedField('shipperContactTitle', true, false, 'Shipper Contact Title'),
            //     new ValidatedField('shipperContactFirstName', true, false, 'Shipper Contact First Name'),
            //     new ValidatedField('shipperContactLastName', true, false, 'Shipper Contact Last Name'),
            //     new ValidatedField('shipperContactPhone', true, false, 'Shipper Contact Telephone'),
            //     new ValidatedField('shipperContactEmail', true, false, 'Shipper Contact Email'),
            //     new ValidatedField('shipperContactDepartment', true, false, 'Shipper Contact Department'),
            //     new ValidatedField('consigneeName', true, false, 'Consignee Name'),
            //     new ValidatedField('consigneeAddressLine1', true, false, 'Consignee AddressLine 1'),
            //     new ValidatedField('consigneeAddressLine2', true, false, 'Consignee AddressLine 2'),
            //     new ValidatedField('consigneeCity', true, false, 'Consignee City'),
            //     new ValidatedField('consigneeCounty', true, false, 'Consignee County'),
            //     new ValidatedField('consigneePostcode', true, false, 'Consignee Postcode'),
            //     new ValidatedField('consigneeCountry', true, false, 'Consignee Country'),
            //     new ValidatedField('consigneeVatNumber', true, false, 'Consignee VAT Number'),
            //     new ValidatedField('consigneeContactFullName', true, false, 'Consignee Contact Selection'),
            //     new ValidatedField('consigneeContactTitle', true, false, 'Consignee Contact Title'),
            //     new ValidatedField('consigneeContactFirstName', true, false, 'Consignee Contact First Name'),
            //     new ValidatedField('consigneeContactLastName', true, false, 'Consignee Contact Last Name'),
            //     new ValidatedField('consigneeContactPhone', true, false, 'Consignee Contact Phone'),
            //     new ValidatedField('consigneeContactEmail', true, false, 'Consignee Contact Email'),
            //     new ValidatedField('customerRef', true, false, 'Customer Ref 1'),
            //     new ValidatedField('customerRefTwo', true, false, 'Customer Ref 2'),
            //     new ValidatedField('collectByDate', true, false, 'Collect By Date'),
            //     new ValidatedField('collectByTime', true, false, 'Collect By Time'),
            //     new ValidatedField('deliveryDate', true, false, 'Delivery Date'),
            //     new ValidatedField('deliveryTime', true, false, 'Delivery Time'),
            //     new ValidatedField('currency', true, false, 'Consignment Currency'),
            //     new ValidatedField('value', true, false, 'Consignment Value'),
            //     new ValidatedField('service', true, false, 'Service Type'),
            //     new ValidatedField('termsOfShipment', true, false, 'Terms Of Shipment'),
            //     new ValidatedField('description', true, false, 'Consignment Description'),
            //     new ValidatedField('comments', true, false, 'Consignment Comments'),
            //     new ValidatedField('pieces', true, false, 'Dims Pieces'),
            //     new ValidatedField('length', false, false, 'Dims Length'),
            //     new ValidatedField('width', false, false, 'Dims Width'),
            //     new ValidatedField('height', false, false, 'Dims Height'),
            //     new ValidatedField('weight', false, false, 'Dims Weight'),
            //     new ValidatedField('packaging', false, false, 'Dims Packaging'),
            //     new ValidatedField('totalPieces', true, false, 'Dims Total Pieces'),
            //     new ValidatedField('totalWeight', true, false, 'Dims Total Weight'),
            //     new ValidatedField('customsStatus', true, false, 'Customs Status'),
        ]

    }

}
